import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { truthy } from '@nestech/utils';
import { MemberStore } from '@web/service';
import { firstValueFrom } from 'rxjs';

export const memberBlocked: CanMatchFn = async () => {
  const memberStore = inject(MemberStore);
  const member = await firstValueFrom(memberStore.member$.pipe(truthy()));
  return member.allowWebPortal === false;
};

export const memberNotBlocked: CanMatchFn = async (...args) => {
  return !(await memberBlocked(...args));
};
